import { combineReducers } from 'redux'

export const layouts = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_LAYOUTS':
      return { ...state, ...action.layouts }
    default:
      return state
  }
}

export const data = (state = {}, action) => {
  switch(action.type){
    case 'INCREMENT_LOADING':
      return Object.assign({}, state, {loading: state.loading + 1})
    case 'DECREMENT_LOADING':
      return Object.assign({}, state, {loading: state.loading - 1})
    case 'CLEAR_STATE':
      return action.initialState
    case 'RECEIVE_LOANS':
      return Object.assign({}, state, {loans: action.loans})
    case 'RECEIVE_CREDIT_CARD_ACCOUNTS':
      return Object.assign({}, state, {credit_card_accounts: action.credit_card_accounts})
    case 'RECEIVE_PRODUCTS':
      return Object.assign({}, state, {loans: action.loans, credit_card_accounts: action.credit_card_accounts})
    case 'RECEIVE_CUSTOMER_APPLICATIONS':
      const customer_applications = state.customer_applications.concat(action.customer_applications)
      return Object.assign({}, state, {customer_applications: customer_applications })
    case 'RECEIVE_AUTHENTICATION':
      return Object.assign({}, state, {config: {api_token: action.api_token, client_install: action.client_install, client_version: action.client_version}})
    case 'RECEIVE_CUSTOMER':
      return Object.assign({}, state, {customer: action.customer})
    case 'RECEIVE_BANK_ACCOUNT':
      return Object.assign({}, state, {bank_account: action.bank_account})
    case 'RECEIVE_ACTIONABLE_PAYMENTS':
      return Object.assign({}, state, {actionable_payments: action.actionable_payments})
    case 'RECEIVE_WORKFLOW_NOTICES':
      return Object.assign({}, state, {workflow_notices: action.notices})
    case 'RECEIVE_NOTICES':
      return Object.assign({}, state, {notices: action.notices})
    case 'REMOVE_WORKFLOW_NOTICE':
      const { workflow_notices = [] } = state
      return Object.assign({}, state, {workflow_notices: workflow_notices.slice(action.index + 1, action.index + 2)})
    case 'REMOVE_NOTICE':
      const { notices = []} = state
      return Object.assign({}, state, {notices: notices.filter(({notice_type}) => notice_type !== action.notice_type)})
    default:
      return state
  }
}

export default combineReducers({layouts, data})
